import React from 'react';
import { EmptyState } from '../EmptyState';
import classNames from 'classnames';

interface PropTypes {
  header?: JSX.Element;
  title: string;
  supportEmail: string;
  helpCenterUrl: string;
  cardless?: boolean;
  excludeImage?: boolean;
  imageSrc?: string;
  imageClassNames?: string;
  homepageLink?: boolean;
  classNames?: string;
  innerMostClassName?: string;
  actionButton?: React.ReactNode;
  titleClassName?: string;
  textFontSize?: string;
  isResponsive?: boolean;
}

export function NotFoundState(props: PropTypes) {
  return (
    <EmptyState
      {...props}
      text={
        <p>
          For more information, contact us at{' '}
          <a
            href={`mailto:${props.supportEmail}`}
            className={classNames('fw-normal text-info')}
          >
            {' '}
            {props.supportEmail}{' '}
          </a>{' '}
          or visit our{' '}
          <a
            href={props.helpCenterUrl}
            target='_blank'
            rel='noopener noreferrer'
            className={classNames('fw-normal text-info')}
          >
            Help Centre
          </a>
          .
        </p>
      }
    />
  );
}
